// Scroll-reveal animations are a progressive enhancement only.
// On mobile (iOS Safari IntersectionObserver/compositing is unreliable during
// momentum scrolling) and with reduced motion, content renders visible at once.
export const revealEnabled: boolean =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(min-width: 768px) and (prefers-reduced-motion: no-preference)").matches;

/** Wrap a Framer Motion `initial` value; returns `false` (render final state) when reveals are disabled. */
export function reveal<T>(initial: T): T | false {
  return revealEnabled ? initial : false;
}
